import React from 'react';
import { gridConnectionsIndexRoute } from '@/modules/charge-center/grid-connections/index/route';
import { createRoute } from '@tanstack/react-router';

// ! Index route as a temporary fix for the Outlet not being correct
export const chargePointsRoute = createRoute({
  getParentRoute: () => gridConnectionsIndexRoute,
  path: 'charge-points',
  component: React.lazy(async () => await import('@/app/routes/ChargeCenter/ChargePointTab')),
  wrapInSuspense: true,
});
